export default __webpack_public_path__ + "pgnv-assets/7d41253d203df9be162f793efc13e82f.png";